import { getColumnNameFromGeoColumn } from 'features/builder/state/builderSliceUtils'

export const generateCreateTableFromQuery = ({ output, query, geoColumn }) => {
  const geoColumnName = getColumnNameFromGeoColumn(geoColumn)
  return `
    CREATE TABLE \`${output}\` CLUSTER BY ${geoColumnName} AS (
      ${query}
    )
  `
}
